module.exports = __webpack_public_path__ + "img/LPW_Sword.43b70849.png";